import { RATE_TYPE_LABEL_MAP } from './rate-type-label-map';
import type { RateTypes } from './rate-types';

export const RATE_TYPE_OPTIONS = Object.entries(RATE_TYPE_LABEL_MAP).map(
  ([value, label]) => ({
    value: Number(value) as RateTypes,
    label,
  }),
);
